<script setup lang="ts">

const props = defineProps<{
  apiData: any,
  type: string
}>();

const rangeData = ref(props.apiData ? Number(props.apiData.totalLinkageRate.toFixed(1)) : 0);

// console.log(props.apiData);

onMounted(() => {
  const percentText = document.getElementById('percentText');
    const valueText = document.getElementById('valueText');
    const range = rangeData;
    const waveBack = document.getElementById('waveBack');
    const wavePath = document.getElementById('wavePath');
    const WIDTH = 200, HEIGHT = 200;
    let wavePhase = 1;

    function noisyAmplitude(x, phase) {
      return 1
        + 0.15 * Math.sin(x / 12 + phase * 1.7)
        + 0.11 * Math.cos(x / 14 + phase * 2.1)
        + 0.09 * Math.sin(x / 9 + phase * 3.3);
    }

    function drawWave(level, phase) {
      const minAmplitude = 3.5;
      const maxAmplitude = 12.5;
      const amplitude = minAmplitude + (maxAmplitude - minAmplitude) * level;
      const waveLength = WIDTH / 1.1;
      const centerY = HEIGHT * (1 - level);
      const shiftSpeed = 0.015;

      let pathBack = `M 0 ${HEIGHT} L 0 ${centerY}`;
      let pathFront = `M 0 ${HEIGHT} L 0 ${centerY}`;
      for (let x = 0; x <= WIDTH; x += 1) {
        const noisy = amplitude * noisyAmplitude(x, phase);

        // 뒷파도: phase + Math.PI + 흐름 shiftSpeed
        let yBack = centerY +
          Math.sin((x / waveLength) * 2 * Math.PI + phase + Math.PI + x * shiftSpeed) * noisy;
        yBack = Math.max(centerY - amplitude * 1.8, Math.min(HEIGHT, yBack));
        pathBack += ` L ${x} ${yBack}`;

        // 앞파도: phase + 흐름 shiftSpeed
        let yFront = centerY +
          Math.sin((x / waveLength) * 2 * Math.PI + phase + x * shiftSpeed) * noisy;
        yFront = Math.max(centerY - amplitude * 1.5, Math.min(HEIGHT, yFront));
        pathFront += ` L ${x} ${yFront}`;
      }
      pathBack += ` L ${WIDTH} ${HEIGHT} Z`;
      pathFront += ` L ${WIDTH} ${HEIGHT} Z`;

      waveBack.setAttribute('d', pathBack);
      wavePath.setAttribute('d', pathFront);
    }

    function animate() {
      wavePhase += 0.055; // 빠르고 자연스럽게
      const value = Number(range.value);
      const level = value / 100;
      drawWave(level, wavePhase);
      requestAnimationFrame(animate);
    }

    // range.addEventListener('input', function () {
    //   valueText.textContent = this.value;
    //   percentText.textContent = this.value + '%';
    // });
    // valueText.textContent = range.value;
    // percentText.textContent = range.value + '%';
    animate();
})
</script>

<template>
  <div class="linkage-info-card common-card dashboard" v-if="props.type === 'dashboard'">
    <div class="header">
      <div class="title">
        연동율
      </div>
    </div>
    <div class="content">
      <div class="circle-wrap">
        <div class="water-container">
          <svg id="wavesvg" width="200" height="200" viewBox="0 0 200 200">
            <defs>
              <clipPath id="circleClip">
                <circle cx="100" cy="100" r="100" />
              </clipPath>
            </defs>
            <g clip-path="url(#circleClip)">
              <circle cx="100" cy="100" r="100" fill="#b5b5b5" />
              <path id="waveBack" fill="#B1BAD7"/>
              <path id="wavePath" fill="#2590F9"/>
            </g>
          </svg>
        </div>
        <div class="percent-text" id="percentText">
          {{rangeData}}
          <span class="unit">%</span>
        </div>
      </div>
    </div>
  </div>
  <div class="linkage-info-card map" v-else-if="props.type === 'map'">
    <div class="content">
      <div class="circle-wrap">
        <div class="water-container">
          <svg id="wavesvg" width="200" height="200" viewBox="0 0 200 200">
            <defs>
              <clipPath id="circleClip">
                <circle cx="100" cy="100" r="100" />
              </clipPath>
            </defs>
            <g clip-path="url(#circleClip)">
              <circle cx="100" cy="100" r="100" fill="#b5b5b5" />
              <path id="waveBack" fill="#B1BAD7"/>
              <path id="wavePath" fill="#2590F9"/>
            </g>
          </svg>
        </div>
        
        <div class="percent-text" id="percentText">
          <div class="title">
            연동률
          </div>
          <div class="value">
            {{rangeData}}<span class="unit"> %</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/linkage-info-card.scss";
@use "@/assets/styles/design-toc/define.scss";
@use "@/assets/styles/design-toc/common-card.scss";
</style>